/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from 'purify-ts';
import { getStoreBuilder } from 'vuex-typex';
import client from '@/client';
import * as models from '@/models';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
const moduleBuilder = storeBuilder.module('peer_feedback', {
    connections: {},
    loaders: {
        peerFeedbackConnections: {},
    },
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function addOrUpdateUser(context, user) {
    return context.dispatch('users/addOrUpdateUser', { user }, { root: true });
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var PeerFeedbackStore;
(function (PeerFeedbackStore) {
    const commitClearAllConnections = moduleBuilder.commit((state, _) => {
        state.connections = {};
        state.loaders.peerFeedbackConnections = {};
    }, 'commitClearAllConnections');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.commitClearConnections = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, { assignmentId }) => {
        utils.vueDelete(state.connections, assignmentId);
        utils.vueDelete(state.loaders.peerFeedbackConnections, assignmentId);
    }, 'commitClearConnections');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.commitSetConnectionsForUser = moduleBuilder.commit((state, payload) => {
        if (state.connections[payload.assignmentId] == null) {
            utils.vueSet(state.connections, payload.assignmentId, {});
        }
        utils.vueSet(state.connections[payload.assignmentId], payload.peerId, new Set(payload.subjects.map(s => s.id)));
    }, 'commitSetConnectsionsForUser');
    // eslint-disable-next-line
    function _getConnectionsForUser(state) {
        return (assignment, userId) => {
            const userIds = Maybe.fromNullable(state.connections[assignment.id]?.[userId]);
            return userIds.map(ids => utils.sortBy(utils.filterMap(Array.from(ids, id => models.User.findUserById(id)), item => Maybe.fromNullable(item)), user => [user.getDisplayName(assignment)]));
        };
    }
    const commitLoader = moduleBuilder.commit((state, 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    payload) => {
        const { assignmentId, userId, maybeLoader } = payload;
        let byAssig = state.loaders.peerFeedbackConnections[assignmentId];
        if (byAssig == null) {
            byAssig = {};
            state.loaders.peerFeedbackConnections[assignmentId] = byAssig;
        }
        maybeLoader.caseOf({
            Just: loader => utils.vueSet(byAssig, userId, loader),
            Nothing: () => utils.vueDelete(byAssig, userId),
        });
    }, 'commitLoader');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.getConnectionsForUser = moduleBuilder.read(_getConnectionsForUser, 'getConnectionsForUser');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.loadConnectionsForUser = moduleBuilder.dispatch(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (context, payload) => {
        const { assignment, userId, force = false } = payload;
        const state = context.state;
        if (!force && _getConnectionsForUser(state)(assignment, userId).isJust()) {
            return null;
        }
        let loader = state.loaders.peerFeedbackConnections?.[assignment.id]?.[userId];
        if (force || loader == null) {
            loader = client.assignment
                .getPeerFeedbackSubjects({ assignmentId: assignment.id, userId })
                .run()
                .then(response => response.unsafeCoerce())
                .then(async ({ cgResult }) => {
                commitLoader({
                    assignmentId: assignment.id,
                    userId,
                    maybeLoader: Maybe.empty(),
                });
                const users = cgResult.map(d => d.subject);
                await Promise.all(users.map(user => addOrUpdateUser(context, user)));
                PeerFeedbackStore.commitSetConnectionsForUser({
                    assignmentId: assignment.id,
                    peerId: userId,
                    subjects: users,
                });
            });
            commitLoader({
                assignmentId: assignment.id,
                userId,
                maybeLoader: Maybe.of(loader),
            });
        }
        return loader;
    }, 'loadConnectionsForUser');
    utils.signal.AFTER_USER_LOGGED_OUT.register(() => {
        commitClearAllConnections();
    });
})(PeerFeedbackStore || (PeerFeedbackStore = {}));
